<section
  class="rs-content-wrapper rs-header-has-level2"
  id="mobileLevelTwo"
  *ngIf="!hasError || selectedProduct || isPending"
>
  <ng-container *ngIf="selectedProduct; else skeleton"
    ><main id="maincontent" role="main">
      <section class="rs-es-first-section">
        <mprd-back-link></mprd-back-link>
        <div class="row">
          <div class="columns small-12">
            <h1 class="rs-tit1-sp rs-txt-c2 rs-has-subtit" data-cy="mobileLevelTwoDescription">
              {{ selectedProduct?.productDescription }}
            </h1>
            <p class="rs-txt-s5 rs-txt-c2 small-only-text-center" x-ms-format-detection="none">
              <mprd-access-number-formatter
                [accessNumber]="selectedProduct?.accessNumber"
                [plc]="selectedProduct?.plc"
              ></mprd-access-number-formatter>
            </p>
            <a
              href="javascript:void(0)"
              [routerLink]="['/details/mobile/joint-offer']"
              class="rs-btn rs-btn-third rs-btn-neg"
              *ngIf="selectedProduct && jointOffer && isEBU === false"
              data-cy="jointOfferButton"
              >{{ 'mobile.jointOffer.manage' | translate
              }}<i class="rs-icon-btn-third rs-margin-left1" aria-hidden="true"></i
            ></a>
            <a
              href="{{ 'mobile.noJointOffer.catalogueLink' | translate }}"
              target="_blank"
              class="rs-btn rs-btn-third rs-btn-neg"
              *ngIf="selectedProduct && !jointOffer && isEBU === false"
              data-tms-event="link-click"
              data-tms-link-zone="mobile options"
              attr.data-tms-link-name="{{ 'mobile.noJointOffer.catalogue' | translate }}"
              attr.data-tms-link-url="{{ 'mobile.noJointOffer.catalogueLink' | translate }}"
              data-cy="jointOfferMarketing"
              >{{ 'mobile.noJointOffer.catalogue' | translate
              }}<i class="rs-icon-btn-third rs-margin-left1" aria-hidden="true"></i
            ></a>
            <div class="panel rs-panel-big clearfix">
              <mprd-usage-header
                [product]="selectedProduct"
                [remainingDaysLabel]="remainingDaysLabel"
                *ngIf="remainingDaysLabel"
              ></mprd-usage-header>
              <div class="row" data-masonry-container="">
                <div class="columns small-12 medium-6" data-masonry-item-sizer=""></div>
                <div class="columns small-12 medium-6" data-masonry-item="">
                  <div class="rs-margin-bottom2">
                    <px-usage-level-2-container
                      [product]="usageProduct"
                      (usageRemainingDays)="usageInitializedWith($event)"
                    ></px-usage-level-2-container>
                  </div>
                </div>
                <mprd-pricing-plan
                  [customerAccount]="customerAccount"
                  [mobileProductDetails]="selectedProduct"
                  *ngIf="isEBU === false"
                ></mprd-pricing-plan>
              </div>
              <div class="rs-me"></div>
            </div>
            <div class="rs-mh-s2 rs-mh-m6"></div>
            <div class="rs-le2"></div>
          </div>
        </div>
      </section></main
  ></ng-container>
  <ng-template #skeleton>
    <section class="rs-es-first-section">
      <div class="row">
        <div class="columns small-12">
          <div class="small-only-text-center">
            <div
              class="panel rs-inline-block rs-wd-s30 rs-wd-m31 rs-h-s4 rs-h-m5 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
            ></div>
          </div>
          <div class="small-only-text-center">
            <div>
              <div
                class="panel rs-inline-block rs-wd-s14 rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
              ></div>
            </div>
          </div>
          <div class="panel rs-panel-big clearfix">
            <div class="row" data-masonry-container="">
              <div class="columns small-12" data-masonry-item-sizer=""></div>
              <div class="columns small-12" data-masonry-item="">
                <px-usage-level-2-container></px-usage-level-2-container>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </ng-template>
</section>
